<template>
  <label class="imageUploader_box" for="imageUploader">
    <div :class="{ imageUploader: !image.preview, imageUploader_done: image.preview }">
      <input class="file-input" type="file" name="image" id="imageUploader" accept=".png, .jpg, .jpeg, image/*"
        @change="previewImage" v-validate="'dimensions:720,240'" v-if="tipo == 'logo' || tipo == 'nlogo'"
        key="image-logo">
      <input class="file-input" type="file" name="image" id="imageUploader" accept=".png, .jpg, .jpeg, image/*"
        @change="previewImage" v-validate data-vv-rules="minDimensions:500,200" v-if="tipo == 'controlpoint'"
        key="image-checkpoint">
      <input class="file-input" type="file" name="image" id="imageUploader" accept=".png, .jpg, .jpeg, image/*"
        @change="previewImage" key="image-alert" v-else>
      <img id="imagePreview" class="image-preview" :src="image.preview" v-show="image.preview && !errors.has('image')">
      <span class="imageUploader_box__placeholder" v-show="!image.preview && !errors.has('image')">
        <span v-if="tipo == 'logo' || tipo == 'nlogo'">{{ text }} en PNG (720 x 240px)</span>
        <span v-if="tipo == 'controlpoint'">{{ text }} en PNG (mínimo: 500 x 200px)</span>
        <span v-else>{{ text }}</span>
        <span class="imageUploader_box__placeholder__contentIcon">
          <i class="item_icon material-icons">publish</i>
        </span>
      </span>
      <span class="color-warning-msg" v-show="errors.has('image')">{{ errors.first('image') }}</span>
    </div>
  </label>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "imageUploader",
  props: ["text", "tipo", "placeholder", "done"],
  emits: ["imageset"],
  data() {
    return {
      image: {
        preview: "",
        file: {}
      },
      imagechange: false
    };
  },
  watch: {
    imagechange: function (newimage) {
      if (this.tipo == "logo") {
        this.$store.commit("changeLogo", this.image);
      } else if (this.tipo == "controlpoint") {
        this.$store.commit("addImageTemp", this.image);
      } else if (this.tipo == "nlogo") {
        this.$emit("imageset", this.image);
      } else {
        console.log("emit imageset");

        this.$emit("imageset", this.image);
        
      }
    },
    done: {
      handler: function(n,o){
        if(n){
          this.image = {
          preview: "",
          file: {}
        }
        }
      },
      immediate: false
    }
  },
  computed: {
    ...mapGetters(["role"])
  },
  created: function () {
    if (this.$route.params.id && !["alert-detail", "alert-user"].includes(this.$route.name)) {
      if (this.$store.getters.imageTemp) {
        this.image.preview = this.$store.getters.imageTemp.preview;
      }
      if (this.placeholder) {
        this.image.preview = this.placeholder;
      }
    }
    console.log(this.text);

    // this.$validator.extend("minDimension", {
    //   getMessage: (field, args) =>
    //     `La ${field} debe tener un minimo de ${args[0]} px y un maximo ${args[1]} px`,
    //   validate: this.validate$c2
    // });
  },
  methods: {
    previewImage() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var oFReader = new FileReader();
          oFReader.readAsDataURL(
            document.getElementById("imageUploader").files[0]
          );
          oFReader.onload = oFReader => {
            this.image.preview = oFReader.target.result;
            this.image.file = document.getElementById("imageUploader").files[0];
            this.imagechange = true;
          };
          oFReader.onabort = oFReader => { };
        }
      });
      // if(this.$route.params.id){
      //   this.$validator.validate('image',)
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "./../../assets/styles/2.tools/mixins/_navegators.scss";
// @import "../../assets/styles/1.settings/_index.scss";
.imageUploader {
  @media screen and (min-width: 678px) {
    height: 40px;
    box-shadow: 0px 3px 1px -3px rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-style: solid;
    border-width: 0.2px;
    border-color: #dbdbdb;
    margin: 25px;
    cursor: pointer;
    padding-top: 25px;
    padding-bottom: 25px;
  }

  // min-width: 400px;
  // width: 50%;
}

.imageUploader_done {
  height: 140px;
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-style: solid;
  border-width: 0.2px;
  border-color: #cccccc;
  margin: 25px;
  cursor: pointer;
}

.imageUploader_box {
  height: 100%;
  width: fit-content;
  margin: 0 auto;
  cursor: pointer;
  display: inherit;
  justify-content: center;
  align-items: center;
  //add color
  color: #5e5e5e;
  font-size: 15px;

  // padding: 25px 20px;
}

.imageUploader_box__placeholder {
  display: none;

  @media screen and (min-width: 678px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;

    &__contentIcon {
      position: relative;

      .item_icon {
        position: relative;
        top: 1px;
        color: dodgerblue;
        transform: scale(0.9);
        // margin-left: 15px;
      }
    }
  }
}

.image-preview {
  height: 120px;
  width: 360px;
}

.file-input {
  display: block;
  width: 100%;
  height: 50px;
  position: static;

  @media screen and (min-width: 678px) {
    display: none;
  }
}

.color-warning-msg {
  color: #ff5a5f;
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/imageUploader.vue